import { AddIcon, RepeatIcon, ViewIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Input,
  Text,
  Tooltip
} from "@chakra-ui/react";
import { GetLayout } from "components/get-layout";
import { useEffect, useMemo, useState } from "react";
import {
  CustomTableColor,
  CustomTableColorProps
} from "components/dynamic-table/color-table";
import { PageTitle } from "components/title-with-back-button";
import {
  ModalConsultaExtratoOnline,
  openModalConsultaExtratoOnline
} from "components/consulta-extrato-online-components/modal-view-consulta-extrato";
import {
  ModalCreateExtrato,
  openModalCreateExtrato
} from "components/consulta-extrato-online-components/modal-create-extrato";
import {
  ExtratoEndpoints,
  ExtratoRow
} from "components/consulta-extrato-online-components/utils";
import { maskDate } from "utils/string-formats";
import { RoutePermissionFunction } from "router-manager/parts";

export default function ConsultaExtratoPage() {
  const [inputBeneficio, setInputBeneficio] = useState("");
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [allRows, setAllRows] = useState<ExtratoRow[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const pageSize = 10;

  const filterArrayBy = (array: ExtratoRow[], filterValue: string) => {
    return array.filter((row) => row.beneficio.includes(filterValue));
  };

  const filteredRows = useMemo(
    () => filterArrayBy(allRows, inputBeneficio),
    [allRows, inputBeneficio]
  );

  const onUpdate = async (page = 0) => {
    setIsLoadingList(true);
    try {
      const data = await ExtratoEndpoints.getExtratos(page, pageSize);
      setAllRows(data);
      setHasNextPage(data.length === pageSize);
      setCurrentPage(page);
      setInputBeneficio("");
    } finally {
      setIsLoadingList(false);
    }
  };

  useEffect(() => {
    onUpdate(0);
  }, []);

  const onPrevPage = () => {
    if (currentPage > 0) {
      onUpdate(currentPage - 1);
    }
  };

  const onNextPage = () => {
    if (hasNextPage) {
      onUpdate(currentPage + 1);
    }
  };

  const onFirstPage = () => {
    onUpdate(0);
  };

  const fomartDate = (value: string) => {
    const split = value.split("T");
    const date =
      split[0].substring(8, 10) +
      "/" +
      split[0].substring(5, 7) +
      "/" +
      split[0].substring(0, 4);
    const hours = split[1].split(".")[0];
    return date + " " + hours;
  };

  const columns: CustomTableColorProps["columns"] = [
    {
      name: "Benefício",
      render: (row: ExtratoRow) => <Text>{row.beneficio}</Text>
    },
    {
      name: "Data Criação",
      render: (row: ExtratoRow) => <Text>{fomartDate(row.dataCriacao)}</Text>
    },
    {
      name: "Usuário",
      render: (row: ExtratoRow) => <Text>{row.userUsername}</Text>
    },
    {
      name: "Ações",
      render: (row: ExtratoRow) => (
        <Tooltip label="Visualizar">
          <IconButton
            aria-label="Visualizar"
            onClick={() => openModalConsultaExtratoOnline(row)}
            icon={<ViewIcon />}
          />
        </Tooltip>
      )
    }
  ];

  return (
    <GetLayout title="Consulta Extrato Online">
      <Box borderRadius="10px" w="100%" mb="16px">
        <Grid templateColumns={"1fr 160px 160px"} gap="16px">
          <Box>
            <Text mb="8px">Pesquisar Benefício</Text>
            <Input
              value={inputBeneficio}
              onChange={(e) => setInputBeneficio(e.target.value)}
              variant="outline-custom"
            />
          </Box>

          <Box>
            <Text mb="8px">&nbsp;</Text>
            <Button
              w="100%"
              leftIcon={<AddIcon />}
              onClick={() =>
                openModalCreateExtrato({ onUpdate: () => onUpdate(0) })
              }
              size="sm"
            >
              Novo Extrato
            </Button>
          </Box>

          <Box>
            <Text mb="8px">&nbsp;</Text>
            <Button
              w="100%"
              leftIcon={<RepeatIcon />}
              onClick={() => onUpdate(0)}
              isLoading={isLoadingList}
              size="sm"
            >
              Atualizar
            </Button>
          </Box>
        </Grid>
      </Box>

      <CustomTableColor
        columns={columns}
        rows={filteredRows}
        isLoading={isLoadingList}
        currentPage={currentPage}
        onPrevPage={onPrevPage}
        onNextPage={onNextPage}
        onFirstPage={onFirstPage}
        pageSize={pageSize}
      />
      <ModalConsultaExtratoOnline />
      <ModalCreateExtrato />
    </GetLayout>
  );
}

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.setUserTypesPermission([
    "SUPER",
    "REGIONAL",
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO",
    "PARCEIRO_MASTER",
    "PARCEIRO_VENDEDOR",
    "PARCEIRO_OPERACIONAL",
    "ASCOM"
  ]);
  route.setColomboUserTypesPermission([
    "COMERCIAL",
    "PARCEIRO_GERENTE_ESTRATEGICO",
    "PARCEIRO_GERENTE_VAREJO"
  ]);
};
